/* eslint @typescript-eslint/no-var-requires: "off" */
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import AddInst from "./addIns";
import Utils from "../constant/Utils";

// const api = require("../constant/API");

const Institution = () => {
  const [searchInput, setSearchInput] = useState("");
  const [inst, setInst] = useState([]);
  const [viewInst, setViewInst] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const [institutionName, setInstitutionName] = useState("");
  const [group, setGroup] = useState("");
  const [type, setType] = useState("");
  const [joinDate, setJoinDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
  });
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [userName, setUserName] = useState("");
  const [exitDate, setExitDate] = useState("");
  const [status, setStatus] = useState("");
  const [groupList, setGroupList] = useState([]);
  const [typeList, setTypeList] = useState([]);

  const formRef = useRef(null);

  const roleId = localStorage.getItem("RoleId");
  const userId = localStorage.getItem("UserId");

  const didFetch = useRef(false);

  useEffect(() => {
    // console.log("didFetch", didFetch.current)
    if (!didFetch.current) {
      didFetch.current = true;
      instList();
    }
  }, []);

  function instList() {
    const getInstList = api.InstitutionList;
    fetch(getInstList, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + Utils.getAccessToken()
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.error == true) {
          if (result.code == 401) {
            Utils.logoutUser();
          }
        } else {
          if (result.data != null) {
            setInst(result.data);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      })
  }

  function viewInstitute(ins) {
    setViewInst(ins);
    const joinDate = new Date(ins.institutionJoinDate).toLocaleDateString('en-GB');
    const endDate = new Date(ins.institutionExitDate).toLocaleDateString('en-GB');
    const instituteWithFormattedDate = { ...ins, institutionJoinDate: joinDate, institutionExitDate: endDate };
    setViewInst(instituteWithFormattedDate);
  }

  function listGroups() {
    const getGroupList = api.adminGroupList;
    fetch(getGroupList, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + Utils.getAccessToken()
      },
    })
      .then((lstResponse) => lstResponse.json())
      .then((lstResult) => {
        if (lstResult.error == true) {
          if (lstResult.code == 401) {
            Utils.logoutUser();
          }
        } else {
          if (lstResult.data != null) {
            setGroupList(lstResult.data)
          }
        }
      })
      .catch((error) => {
        console.log("Failed to fetch the group list", error);
      })
  }

  function listTypes() {
    const getTypeList = api.adminTypeList;
    fetch(getTypeList, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + Utils.getAccessToken()
      },
    })
      .then((typLstResponse) => typLstResponse.json())
      .then((typLstResult) => {
        if (typLstResult.error == true) {
          if (typLstResult.code == 401) {
            Utils.logoutUser();
          }
        } else {
          if (typLstResult.data != null) {
            setTypeList(typLstResult.data)
          }
        }
      })
      .catch((error) => {
        console.log("Failed to fetch the type list", error);
      })
  }

  function editInst(row) {
    const id = row.institutionId;
    setSelectedRow(row.institutionId);

    listGroups();
    listTypes();

    const getInst = api.InstitutionList + "/" + id;
    fetch(getInst, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + Utils.getAccessToken()
      },
    })
      .then((InsResponse) => InsResponse.json())
      .then((insResult) => {
        if (insResult.error == true) {
          if (insResult.code == 401) {
            Utils.logoutUser();
          }
        } else {
          const res = insResult.data[0];
          setInstitutionName(res.institutionName)
          setGroup(res.institutionGroup)
          setType(res.institutionType)
          setJoinDate(res.institutionJoinDate)
          setAddress(res.institutionAddress)
          setCity(res.institutionCity)
          setState(res.institutionState)
          setPinCode(res.institutionPincode)
          setPhone(res.institutionPhone)
          setEmail(res.institutionEmail)
          setContactName(res.institutionContactName)
          setContactPhone(res.institutionContactPhone)
          setLatitude(res.institutionLatitude)
          setLongitude(res.institutionLongitude)
          setUserName(res.institutionUsername)
          setExitDate(res.institutionExitDate)
          setStatus(res.institutionStatus)
        }
      })
      .catch((error) => {
        console.log("Failed to fetch the institue details", error);
      })
  }

  function updateInst(e) {
    e.preventDefault();
    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
    } else {
      const formData = new FormData();
      formData.append("institutionId", selectedRow);
      formData.append("institutionName", institutionName);
      formData.append("institutionGroup", group);
      formData.append("institutionType", type);
      formData.append("institutionJoinDate", joinDate);
      formData.append("institutionAddress", address);
      formData.append("institutionCity", city);
      formData.append("institutionState", state);
      formData.append("institutionPincode", pinCode);
      formData.append("institutionPhone", phone);
      formData.append("institutionEmail", email);
      formData.append("institutionContactName", contactName);
      formData.append("institutionContactPhone", contactPhone);
      formData.append("institutionLatitude", latitude);
      formData.append("institutionLongitude", longitude);
      formData.append("institutionUsername", userName);
      formData.append("institutionExitDate", exitDate);
      formData.append("institutionStatus", status);

      const instiUpdate = api.updateInstitute;
      fetch(instiUpdate, {
        method: "POST",
        headers: {
          "Authorization": 'Bearer ' + Utils.getAccessToken()
        },
        body: formData
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.error == true) {
            if (result.code == 401) {
              Utils.logoutUser();
            }
          }
          const resError = result.error;
          const resMsg = result.message;
          if (resError == true) {
            if (resMsg.institutionName) {
              alert(resMsg.institutionName)
            } else if (resMsg.institutionGroup) {
              alert(resMsg.institutionGroup)
            } else if (resMsg.institutionType) {
              alert(resMsg.institutionType)
            } else if (resMsg.institutionUsername) {
              alert(resMsg.institutionUsername)
            }
          } else {
            alert(resMsg);
          }
        })
        .catch((error) => {
          console.log("Failed to update institute", error);
        })
    }
  }

  const filteredData = inst.filter((datas) => {
    const values = Object.values(datas).map((value) =>
      value.toString().toLowerCase()
    );
    return values.some((value) => value.includes(searchInput.toLowerCase()));
  });

  const slNoRender = (rowData, column) => {
    return column.rowIndex + 1;
  };

  const nameRender = (rowData) => {
    return <span>{rowData.institutionName}</span>;
  };

  const groupRender = (rowData) => {
    return <span>{rowData.GroupName}</span>;
  };

  const typeRender = (rowData) => {
    return <span>{rowData.TypeName}</span>;
  };

  const statusRender = (rowData) => {
    return <span>{rowData.institutionStatus == 0 ? "Inactive" : "Active"}</span>;
  };


  const detailsRender = (rowData) => {
    return (
      <Link to="#" data-bs-toggle="modal" data-bs-target="#view-institute" onClick={() => viewInstitute(rowData)}>
        <i className="feather-eye"></i>View Details
      </Link>
    );
  };

  const editDetails = (rowData) => {
    return (
      <Link to="#" data-bs-toggle="modal" data-bs-target="#edit-inst" onClick={() => editInst(rowData)}>
        <i className="feather-edit"></i>Edit
      </Link>
    );
  };

  const editStatus = (rowData) => {
    // if (rowData.institutionStatus == 0) {
    return (
      <Link to="#" data-bs-toggle="modal" data-bs-target="#edit-inst" onClick={() => editInst(rowData)}>
        <i className="feather-edit"></i>Archive
      </Link>
    );
    // }
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <div className="court-tab-content">
            <div className="card card-tableset">
              <div className="card-body">
                <div className="coache-head-blk">
                  <div className="row align-items-center">
                    {roleId == '1' || roleId == '3' ? (

                      <div className="row col-md-12">
                        <div className="col-md-4">
                          <Link
                            to="#"
                            className="btn btn-secondary"
                            data-bs-toggle="modal"
                            data-bs-target="#add-inst"
                          >
                            <i className="feather-plus" />&nbsp;
                            Add Institute
                          </Link>
                        </div>
                      </div>
                    ) : null}
                    <div className="col-md-6">
                    </div>
                    <div className="col-md-6">
                      <div className="dataTables_filter">
                        <label>
                          <input
                            type="text"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            placeholder="Search"
                            className="form-control"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="nav-Recent"
                    role="tabpanel"
                    aria-labelledby="nav-Recent-tab"
                    tabIndex={0}
                  >
                    <div className="table-responsive table-datatble">
                      <DataTable
                        className="table datatable"
                        value={filteredData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                      >
                        <Column
                          sortable
                          field="slNo"
                          body={slNoRender}
                          headerClassName="text-uppercase"
                          header="Sl &nbsp; No"
                        ></Column>
                        <Column
                          sortable
                          field="institutionName"
                          headerClassName="text-uppercase"
                          header="Name"
                          body={nameRender}
                        ></Column>
                        <Column
                          sortable
                          field="GroupName"
                          headerClassName="text-uppercase"
                          header="Group"
                          body={groupRender}
                        ></Column>
                        <Column
                          sortable
                          field="TypeName"
                          headerClassName="text-uppercase"
                          header="Type"
                          body={typeRender}
                          className="table-inset-btn"
                        ></Column>
                        <Column
                          sortable
                          field="institutionStatus"
                          headerClassName="text-uppercase"
                          header="Status"
                          body={statusRender}
                          className="table-inset-btn"
                        ></Column>

                        <Column
                          className="text-link view-detail-pink"
                          body={detailsRender}
                        ></Column>

                        {(roleId == '1' || roleId == '3') ? (
                          <Column
                            className="text-link"
                            body={editDetails}
                          ></Column>
                        ) : null}

                        {/* {(roleId == '1') ? (
                          <Column
                            className="text-link"
                            body={editStatus}
                          ></Column>
                        ) : null} */}
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* upcoming Modal */}
      <div
        className="modal custom-modal fade request-modal"
        id="view-institute"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <div className="form-header modal-header-title">
                <h4 className="mb-0">
                  Institute Details
                </h4>
              </div>
              <Link
                to="#"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="align-center" aria-hidden="true">
                  <i className="feather-x" />
                </span>
              </Link>
            </div>
            <div className="modal-body">
              {/* Court Request */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="card court-information">
                    <div className="card dashboard-card court-information">
                      <div className="card-header">
                        <h4>Basic Details</h4>
                      </div>
                      <div className="appointment-info">
                        <ul className="appointmentset">
                          <li>
                            <h6>Name</h6>
                            <p>{viewInst.institutionName}</p>
                          </li>
                          <li>
                            <h6>Group</h6>
                            <p>{viewInst.GroupName}</p>
                          </li>
                          <li>
                            <h6>Type</h6>
                            <p>{viewInst.TypeName}</p>
                          </li>
                          <li>
                            <h6>Join Date</h6>
                            <p>{viewInst.institutionJoinDate}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card dashboard-card court-information">
                      <div className="card-header">
                        <h4>Additional Details</h4>
                      </div>
                      <div className="appointment-info appoin-border double-row">
                        <ul className="appointmentset">
                          <li>
                            <h6>Address</h6>
                            <p>{viewInst.institutionAddress}</p>
                          </li>
                          <li>
                            <h6>City</h6>
                            <p>{viewInst.institutionCity}</p>
                          </li>
                          <li>
                            <h6>State</h6>
                            <p>{viewInst.institutionState}</p>
                          </li>
                          <li>
                            <h6>Pincode</h6>
                            <p>{viewInst.institutionPincode}</p>
                          </li>
                        </ul>
                      </div>
                      <div className="appointment-info appoin-border double-row">
                        <ul className="appointmentset">
                          <li>
                            <h6>Phone</h6>
                            <p>{viewInst.institutionPhone}</p>
                          </li>
                          <li>
                            <h6>Email</h6>
                            <p>{viewInst.institutionEmail}</p>
                          </li>
                          <li>
                            <h6>Contact Name</h6>
                            <p>{viewInst.institutionContactName}</p>
                          </li>
                          <li>
                            <h6>Contact Phone</h6>
                            <p>{viewInst.institutionContactPhone}</p>
                          </li>
                        </ul>
                      </div>
                      <div className="appointment-info appoin-border double-row">
                        <ul className="appointmentset">
                          <li>
                            <h6>Latitude</h6>
                            <p>{viewInst.institutionLatitude}</p>
                          </li>
                          <li>
                            <h6>Longitude</h6>
                            <p>{viewInst.institutionLongitude}</p>
                          </li>
                          <li>
                            <h6>User Name</h6>
                            <p>{viewInst.institutionUserName}</p>
                          </li>
                          <li>
                            <h6>Exit Date</h6>
                            <p>{(viewInst.institutionExitDate == 'Invalid Date') ? "" : viewInst.institutionExitDate}</p>
                          </li>
                        </ul>
                      </div>
                      <div className="appointment-info appoin-border">
                        <ul className="appointmentset">
                          <li>
                            <h6>Status</h6>
                            <p>{(viewInst.institutionStatus == 1) ? "Active" : "Inactive"}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Court Request */}
            </div>
            <div className="modal-footer">
              <div className="table-accept-btn">
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn cancel-table-btn"
                >
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /upcoming Modal */}

      {/* add inst modal */}
      <AddInst />
      {/* /add inst modal */}

      {/* edit inst modal */}
      <div
        className="modal custom-modal fade request-modal"
        id="edit-inst"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <div className="form-header modal-header-title">
                <h4 className="mb-0">
                  Edit Institute
                </h4>
              </div>
              <Link
                to="#"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="align-center" aria-hidden="true">
                  <i className="feather-x" />
                </span>
              </Link>
            </div>
            <div className="modal-body">
              <form ref={formRef}>
                <div className="row">
                  <div className="mb-10 col-md-4">
                    <label className="form-label">Name</label>
                    <input
                      id="instiName"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={institutionName}
                      placeholder="Institution Name"
                      required
                      onChange={(e) => {
                        setInstitutionName(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Group</label>
                    <Select
                      value={groupList.find(grp => grp.institutionGroupId === group) ? {
                        value: group,
                        label: groupList.find(grp => grp.institutionGroupId === group).institutionGroupName
                      } : null}
                      required
                      onChange={(e) => {
                        setGroup(e.value);
                      }}
                      placeholder="Select Group"
                      options={groupList.map(grp => ({
                        value: grp.institutionGroupId,
                        label: grp.institutionGroupName
                      }))}>
                    </Select>
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Type</label>
                    <Select
                      value={typeList.find(typ => typ.institutionTypeId === type) ? {
                        value: type,
                        label: typeList.find(typ => typ.institutionTypeId === type).institutionTypeName
                      } : null}
                      required
                      onChange={(e) => {
                        setType(e.value);
                      }}
                      placeholder="Select Type"
                      options={typeList.map(typ => ({
                        value: typ.institutionTypeId,
                        label: typ.institutionTypeName
                      }))}>
                    </Select>
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Join Date</label>
                    <input
                      id="instijoinDate"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={joinDate}
                      type="date"
                      required
                      onChange={(e) => {
                        setJoinDate(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-8">
                    <label className="form-label">Address</label>
                    <input
                      id="instiaddress"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={address}
                      placeholder="Institution Address"
                      required
                      onChange={(e) => {
                        setAddress(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">City</label>
                    <input
                      id="instiCity"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={city}
                      placeholder="Institution City"
                      required
                      onChange={(e) => {
                        setCity(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">State</label>
                    <input
                      id="instiState"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={state}
                      placeholder="Institution State"
                      required
                      onChange={(e) => {
                        setState(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Pincode</label>
                    <input
                      id="instiPincode"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={pinCode}
                      placeholder="Institution Pincode"
                      type="number"
                      required
                      onChange={(e) => {
                        setPinCode(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Phone</label>
                    <input
                      id="instiPhone"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={phone}
                      placeholder="Institution Phone"
                      type="number"
                      required
                      onChange={(e) => {
                        setPhone(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Email</label>
                    <input
                      id="instiEmail"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={email}
                      placeholder="Institution Email"
                      type="email"
                      required
                      onChange={(e) => {
                        setEmail(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Contact Name</label>
                    <input
                      id="instiContacttName"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={contactName}
                      placeholder="Institute Contact Name"
                      required
                      onChange={(e) => {
                        setContactName(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Contact Phone</label>
                    <input
                      id="instiContactPhone"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={contactPhone}
                      placeholder="Institute Contact Phone"
                      type="number"
                      required
                      onChange={(e) => {
                        setContactPhone(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Latitude</label>
                    <input
                      id="instiLatitude"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={latitude}
                      placeholder="Institution Latitude"
                      required
                      onChange={(e) => {
                        setLatitude(e.target.value)
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Longitude</label>
                    <input
                      id="instiLongitude"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={longitude}
                      placeholder="Institution Longitude"
                      required
                      onChange={(e) => {
                        setLongitude(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Username</label>
                    <input
                      id="instiUserName"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={userName}
                      placeholder="Institute Username"
                      required
                      onChange={(e) => {
                        setUserName(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-4">
                    <label className="form-label">Exit Date</label>
                    <input
                      id="instiexitDate"
                      className="form-control"
                      style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                      value={exitDate}
                      placeholder="Exit Date"
                      type="date"
                      required
                      onChange={(e) => {
                        setExitDate(e.target.value)
                      }}
                    />
                  </div>

                  <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                    <label className="form-label">Status</label>
                  </div>
                  <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                      <input
                        className="form-check-input text-end"
                        type="checkbox"
                        checked={status === '1'}
                        id="instistatus"
                        onChange={(e) => {
                          setStatus(e.target.checked ? '1' : '0')
                        }}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <div className="table-accept-btn">
                <Link to="#" className="btn btn-primary close" onClick={updateInst} data-bs-dismiss="modal" aria-label="Close">
                  <i className="fas fa-save" />
                  Save
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div >
      {/* /edit inst modal */}
    </>
  );
};

export default Institution;
